module.exports = __webpack_public_path__ + "static/media/eduardo_de_castro_faustino_coelho.ece7641b.jpg";